import { render, staticRenderFns } from "./show-notice-bar.vue?vue&type=template&id=65bb3464&scoped=true&"
import script from "./show-notice-bar.vue?vue&type=script&lang=js&"
export * from "./show-notice-bar.vue?vue&type=script&lang=js&"
import style0 from "./show-notice-bar.vue?vue&type=style&index=0&id=65bb3464&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb3464",
  null
  
)

export default component.exports